@if (alertState.show) {
  <div class="registration-alert" [style.background]="alertState.backgroundColor">
    <img src="{{alertState.icon}}">
    <p class="text-alert">
      {{ alertState.text }}
    </p>
    <button class="close-button" (click)="closeAlert()">
      <img src="../../../../../assets/icons/close_icon.svg" alt="Close Icon" />
    </button>
  </div>
}
